import React, { Fragment } from "react";
import PropTypes from "prop-types";
import Form from "../../common/Form";
import Fieldset from "../../common/Fieldset";
import Files from "../../common/Files";
import { FileComponentNames } from "../../../constants/ComponentConstants";
import { getFilesComponentProps } from "../../../components/common/FilesHelperUtil";
import TextAreaInput from "../../../components/common/TextAreaInput";

const DemoForm = (props) => {
    const {
        model,
        fileComponents,
        fileDownloadUrl,
        onChange,
        onSave,
        onClose,
        onUploadFiles,
        onDeleteFile,
        errors
    } = props;

    const demoFilesMimeTypes = 'application/vnd.ms-excel,application/msexcel, application/x-excel, application/x-msexcel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation, image/png, image/jpeg, image/jpeg, image/gif, image/tiff';
    const demoFilesExtensions = 'pdf, xls, xlsx, doc, docx, ppt, pptx, jpeg, jpg, gif, png, tiff';
    const demoFilesProps = getFilesComponentProps("Demo Files", FileComponentNames.DEMO, fileDownloadUrl, fileComponents, false, mapDropFiles, mapDeleteFile, {
        mimeTypes: demoFilesMimeTypes,
        extensions: demoFilesExtensions
    });

    function mapDropFiles(componentName) {
        return function (files) {
            onUploadFiles(componentName, files);
        };
    }

    function mapDeleteFile(componentName) {
        return function (file) {
            onDeleteFile(componentName, file);
        };
    }

    return (
        <Fragment>
            <Form name="demo"
                title={"Demo"}
                headerVisible
                isNotRequired
                leftButtonLabel={model.datumIndiening ? null : "Bewaren"}
                onLeftButtonClick={onSave}
                rightButtonLabel="Sluiten"
                onRightButtonClick={onClose}>
                <TextAreaInput
                    name="title"
                    label="De titel"
                    value={model.title}
                    onChange={onChange}
                />
                <div className="u-clear" style={{ margin: '20px 30px 0 30px' }}>
                    <div className="o-col-5">
                        <h6>Demo - {model.title}</h6>
                        <p>Welcome to the demo. This is a demo text. Look around. Welcome to the demo. This is a demo text. Look around. Welcome to the demo. This is a demo text. Look around.</p><br />
                    </div>
                    <div className="o-col-7">
                        <Files {...demoFilesProps} />
                    </div>
                </div>
            </Form>
            <Fieldset title="An Extra Fieldset Below The Form">
                The fieldset is placed inside the Fragment, no extra div around the Form and Fieldset
            </Fieldset>
        </Fragment>);
};

DemoForm.propTypes = {
    model: PropTypes.object,
    onChange: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    errors: PropTypes.object,
    onUploadFiles: PropTypes.func.isRequired,
    onDeleteFile: PropTypes.func.isRequired,
    fileDownloadUrl: PropTypes.string.isRequired,
    templateDownloadUrl: PropTypes.string.isRequired,
    fileComponents: PropTypes.object,
    disabled: PropTypes.bool,
    readonly: PropTypes.bool
};

export default DemoForm;